document.addEventListener('DOMContentLoaded', function () {
  const openBtn = document.getElementById('notify-open');
  const closeBtn = document.getElementById('notify-close');
  const popup = document.getElementById('notify-popup');
  const form = document.getElementById('notify-form');

  if (!openBtn || !closeBtn || !popup) return;

  const popupBg = popup.querySelector('.notify-popup-bg');
  const slidecard = popup.querySelector('.notify-slidecard');

  function closePopup() {
    popup.classList.remove('active');

    setTimeout(() => {
      popup.style.display = 'none';
      document.body.style.overflow = '';
    }, 450);
  }

  openBtn.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();

    const newsletterPopup = document.querySelector('#shopify-section-slidecard');
    const newsletterBg = document.querySelector('body > .popup-bg');

    if (newsletterPopup) newsletterPopup.style.display = 'none';
    if (newsletterBg) newsletterBg.style.display = 'none';

    popup.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    requestAnimationFrame(() => {
      popup.classList.add('active');
    });
  });

  closeBtn.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    closePopup();
  });

  popupBg?.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    closePopup();
  });

  slidecard?.addEventListener('click', function (event) {
    event.stopPropagation();
  });

  if (!form) return;

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    const email = form.querySelector('[name="email"]').value;
    const product = form.querySelector('[name="product"]').value;
    const variant = form.querySelector('[name="variant"]').value;
    const productUrl = form.querySelector('[name="product_url"]').value;

    const payload = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email,
                properties: {
                  waitlist_product: product,
                  waitlist_variant: variant,
                  waitlist_url: productUrl
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: "VJdKmg"
            }
          }
        }
      }
    };

    try {
      await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=W7BYxV', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-02-15'
        },
        body: JSON.stringify(payload)
      });

      document.querySelector('.notify-slidecard .slidecard-heading').textContent =
        "YOU'RE ON THE LIST";

      document.querySelector('.notify-slidecard .text-size-large.is-slidecard').textContent =
        "Thank you. We'll notify you as soon as it's available.";

      form.innerHTML = '';

      setTimeout(closePopup, 5000);
    } catch (error) {
      console.error(error);
    }
  });
});